import { render, staticRenderFns } from "./TaskNotifyModal.vue?vue&type=template&id=247d4126&scoped=true&"
import script from "./TaskNotifyModal.vue?vue&type=script&lang=js&"
export * from "./TaskNotifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247d4126",
  null
  
)

export default component.exports